import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import CustomTooltip from '../../CustomTooltip/CustomTooltip';

type Props = {
    url: string;
};

const FormFieldTooltip = ({ url }: Props) => {
    const trimmedUrl = url?.trim();

    if (!trimmedUrl) {
        return null;
    }

    return (
        <CustomTooltip
            arrow
            lazyMountTitle
            trigger="hover"
            placement="bottom-start"
            slotProps={{
                tooltip: {
                    sx: {
                        p: 0,
                        bgcolor: '#fff',
                        border: '1px solid #d9e2ef',
                        borderRadius: '16px',
                        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.16)',
                        maxWidth: 'none',
                        overflow: 'visible',
                    },
                },
                arrow: {
                    sx: {
                        color: '#878787',
                        '&:before': {
                            border: '1px solid #d9e2ef',
                            boxSizing: 'border-box',
                        },
                    },
                },

                popper: {
                    sx: {
                        zIndex: 1500,
                    },
                },
            }}
            title={() => (
                <div
                    style={{
                        width: 'min(840px, 90vw)',
                        height: 'min(560px, 70vh)',
                        background: '#fff',
                        overflow: 'hidden',
                        borderRadius: 16,
                    }}
                >
                    <iframe
                        src={trimmedUrl}
                        title="Field help"
                        width="100%"
                        height="100%"
                        style={{
                            border: 0,
                            display: 'block',
                        }}
                    />
                </div>
            )}
        >
            <InfoOutlined
                fontSize="small"
                style={{
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                    marginLeft: 4,
                    marginTop: 4,
                }}
            />
        </CustomTooltip>
    );
};

export default FormFieldTooltip;